import { SVGProps } from 'react';



function Bubble2Icon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 787 793"
            width="0.992em"
            height="1em"
            {...props}
        >
            <path
                fill="#1688f3"
                d="M627.47 579.219c37.588-58.906-39.014-118.382-25.787-209.114 13.228-90.731 136.298-81.877 78.696-153.812C622.777 144.36 503.472 46.27 371.275 82.367 239.077 118.465 173.004 264.81 151.59 360.682c-21.415 95.874 59.093 43.918 134.028 105.18 74.934 61.261 98.7 117.646 165.71 139.867 85.463 28.339 138.553 32.395 176.141-26.51z"
                opacity={0.1}
            />
            <path
                fill="#1688f3"
                d="M688.68 725.422c53.992-84.613-56.04-170.045-37.04-300.372 19-130.328 195.78-117.61 113.04-220.937-82.74-103.328-254.11-244.223-444-192.373C130.79 63.59 35.882 273.8 5.122 411.514c-30.76 137.714 84.883 63.085 192.52 151.081 107.636 87.997 141.772 168.988 238.027 200.906 122.76 40.707 199.018 46.534 253.01-38.079z"
                opacity={0.05}
            />
        </svg>
    );
}

export default Bubble2Icon;
